import styled from '@emotion/styled'

export const pnArticleVideoClassName = 'pn-article-video'

export interface StyledPNArticleVideoProps {}

export const StyledPNArticleVideo = styled('figure')<StyledPNArticleVideoProps>(
    {
        flexGrow: 1,

        pointerEvents: 'auto',
    },
)
